import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { ACL } from "src/components/acl";
import { Subheading } from "src/components/base/heading";
import { useTranslation } from "react-i18next";
import SINGLE_GROUP_CONTEXT from "src/context/internal/group";

/**
 * The properties for {@link GroupInboundACLs}
 */
export type GroupInboundACLsProps = {};

/**
 * The view to display the Inbound ACLs of a group
 */
function GroupInboundACLs(props: GroupInboundACLsProps) {
    const [t] = useTranslation("admin-group-view");

    const ctx = React.useContext(SINGLE_GROUP_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            <Subheading>{t("heading.add-new-acl")}</Subheading>
            <ACL
                key={"new-inbound"}
                onChange={ctx.reset}
                dst={{ type: "Group", value: ctx.group }}
                startEditable={true}
            />

            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.group.access_rules.inbound.map((acl) => (
                <ACL key={acl.uuid} dst={acl.dst} acl={acl} onChange={ctx.reset} />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/groups/$groupId/_group/inbound-acls")({
    component: GroupInboundACLs,
});
